import { render, staticRenderFns } from "./the-profile-dropdown.vue?vue&type=template&id=4d7915fa&scoped=true"
import script from "./the-profile-dropdown.vue?vue&type=script&lang=js"
export * from "./the-profile-dropdown.vue?vue&type=script&lang=js"
import style0 from "./the-profile-dropdown.vue?vue&type=style&index=0&id=4d7915fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7915fa",
  null
  
)

export default component.exports